import { Box, Flex, Text } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';

import { parseArticle, parseAllArticles } from 'lib/server/articles';
import { ArticleMetaData } from 'lib/shared/types/ArticleMetaData';
import { ArticleAuthor } from 'components/ArticleAuthor';
import { getLayout } from 'layouts/ArticleLayout';
import {
  A,
  P,
  Code,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  HR,
  OL,
  UL,
  LI,
} from 'lib/shared/contentRenderers';
import * as tocRenderers from 'lib/shared/tocRenderers';

export async function getStaticProps(context) {
  const slug = context.params.slug;

  const article = await parseArticle(slug);

  return {
    props: { article },
  };
}

export async function getStaticPaths() {
  const paths = (await parseAllArticles()).map(({ slug }) => ({
    params: {
      slug,
    },
  }));

  return {
    paths,

    fallback: false,
  };
}

export type PostPageProps = {
  article: ArticleMetaData;
};

const components = {
  code: Code,
  a: A,
  p: P,
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
  hr: HR,
  ol: OL,
  ul: UL,
  li: LI,
};

export default function PostPage({
  article: {
    content,
    data: { date, title },
    toc,
  },
}: PostPageProps) {
  return (
    <main>
      <H1>{title}</H1>
      <Flex direction="row" justify="space-between" mb={5}>
        <ArticleAuthor name="Mike Cavaliere" date={date} />
      </Flex>

      {toc && (
        <Box
          p={8}
          pb={2}
          mb={5}
          borderRadius={15}
          borderColor="gray.800"
          borderStyle="solid"
          borderWidth="2px"
          backgroundColor="#F5F5F5"
          as="nav"
        >
          <Text
            textTransform="uppercase"
            fontWeight="bold"
            color="gray.800"
            mb={3}
          >
            Table of Contents
          </Text>
          <ReactMarkdown components={tocRenderers}>{toc}</ReactMarkdown>
        </Box>
      )}

      <article>
        <ReactMarkdown components={components}>{content}</ReactMarkdown>
      </article>
    </main>
  );
}

PostPage.getLayout = getLayout;
